export const REGULAR_REFERRAL = 1;
export const FORWARD_REFERRAL = 2;
export const FOLLOWUP_REFERRAL = 3;